import {Component} from '@angular/core';
import {AssertionUtils} from '../../common/utils/assertion-utils';
import {Unit} from './../../common/unit.enum';
import {CustomCellEditorRendererParams} from './custom-cell-editor-renderer-params.interface';

@Component({
  templateUrl: './custom-cell-editor-renderer.component.html',
  styleUrls: ['./custom-cell-editor-renderer.component.scss']
})
export class CustomCellEditorRendererComponent {
  public unit: Unit;
  public value = '';
  public isPlaceholder = false;

  public constructor() {}

  public agInit(params: CustomCellEditorRendererParams): void {
    this.value = AssertionUtils.isNullOrUndefined(params.value) ? params.placeholder : params.value;
    this.isPlaceholder = AssertionUtils.isNullOrUndefined(params.value);
    this.unit = params.unit;
  }
}
